export default __webpack_public_path__ + "static/media/dollar icon 1.3114622d.svg";